export var textIsLink = function (text) {
    return new RegExp("^https?:").test(text);
};
